import {InjectionToken} from '@angular/core';
import {IReportingModuleConfig} from './reporting-module-config.interface';

export const ReportingModuleConfig = new InjectionToken<IReportingModuleConfig>('ModuleConfig');
